export const CONTENT_TYPE_FORM='application/x-www-form-urlencoded;charset=UTF-8';
export const CONTENT_TYPE_JSON="application/json;charset=UTF-8";
export const IS_IGNORE_LOGIN=false;
export const IS_PRODUCTION=!true;
export const LOGIN_INFO='login_info';
export const PERM_INFO='perm_info';
export const SID='@storage_Key';
export const TOKEN='TOKEN';
export const USER_ID='USER_ID';
export const DEPT_ID='@dept_Key';
export const DEPT_Name='@dept_Name';
export const DEV_ID='@dev_Key';
export const IS_TABLE_STYLE='@table_Key';
export const DEFAULT_PAGE_SIZE = 10;
export const formLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 13 },
  };
export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
export const DEFAULT_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DEFAULT_DATE_TIME_MINUTE_FORMAT = "YYYY-MM-DD HH:mm";
